/* eslint-disable */
export const region7Barangays = [
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'BAHI',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'BASACDACU',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'CANTIGUIB',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'DANGAY',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'EAST POBLACION',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'PONONG',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'TAGBUANE',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'TORIL',
    },
    {
        CITY: 'ALBURQUERQUE',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'ANGILAN',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'BANTOLINAO',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'BICAHAN',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'BITAUGAN',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'BUNGAHAN',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'CANLAAS',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'CAN-OMAY',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'CANSIBUAN',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'CELING',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'DANICOP',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'MAG-ASO',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'QUINAPON-AN',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'TABUAN',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'TAGUBAAS',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'TUPAS',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'UBOJAN',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'ANTEQUERA',
        BARANGAY: 'VILLA AURORA (CANOC-OC)',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'BUENAVENTURA',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'CAMBANAC',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'DASITAM',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'GUIWANON',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'LANDICAN',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'LAYA',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'MONTANA',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'PAMILACAN',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'PAYAHAN',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'TAGUIHON',
    },
    {
        CITY: 'BACLAYON',
        BARANGAY: 'TANDAY',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'BAUCAN NORTE',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'BAUCAN SUR',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'BOCTOL',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'BOYOG NORTE',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'BOYOG PROPER',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'BOYOG SUR',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'CABAD',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'CANDASIG',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'CANTALID',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'CANTOMIMBO',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'DATAG NORTE',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'DATAG SUR',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'DEL CARMEN ESTE (POB.)',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'DEL CARMEN NORTE (POB.)',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'DEL CARMEN SUR (POB.)',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'DEL CARMEN WESTE (POB.)',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'DOROL',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'HAGUILANAN GRANDE',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'HANOPOL ESTE',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'HANOPOL NORTE',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'HANOPOL WESTE',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'MAGSIJA',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'MASLOG',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'SAGASA',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'SAL-ING',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BALILIHAN',
        BARANGAY: 'TAGUSTUSAN',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'BILANGBILANGAN DAKO',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'BILANGBILANGAN DIOT',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'HINGOTANAN EAST',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'HINGOTANAN WEST',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'MALINGIN',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'MANDAWA',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'MAOMAWAN',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'NUEVA ESPERANZA',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'NUEVA ESTRELLA',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'PINAMGO',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'POBLACION (BIEN UNIDO)',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'PUERTO SAN PEDRO',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'SAGASA',
    },
    {
        CITY: 'BIEN-UNIDO',
        BARANGAY: 'TUBORAN',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'BUGANG NORTE',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'BUGANG SUR',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'CABACNITAN',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'CABACNITAN (MAGSAYSAY)',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'CAMBIGSI',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'CAMPAGAO',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'CANSUMBOL',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'DAGOHOY',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'OWAC',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'SUBAYON',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'VILLA SUERTE',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'YANAYA',
    },
    {
        CITY: 'BILAR',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CABATANG',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CAGONGCAGONG',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CAMBAOL',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'CAYACAY',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'DEL MONTE',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'LA HACIENDA',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'PAGAHAT',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'POBLACION (CALINGGANAY)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'PROGRESO',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'PUTLONGCAM',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'SUDLON (OMHOR)',
    },
    {
        CITY: 'ALICIA',
        BARANGAY: 'UNTAGA',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'ALMARIA',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'CANDABONG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'CASICA',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'LINAWAN',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'LUNDAG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'TANOD',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'TAWID',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'VIRGEN',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'ALOJA',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'BEHIND THE CLOUDS',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'BEHIND THE CLOUDS (SAN JOSE)',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'CABACNITAN',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'CAMBACAY',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'CANTIGDAS',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'GARCIA',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'JANLUD',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'POBLACION VIEJA',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'POBLACION VIEJA (LONGSUDAAN)',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'ROSARIOHAN',
    },
    {
        CITY: 'BATUAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'ASINAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BALUARTE',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BANTUAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BONOTBONOT',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BUGAONG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CAMBUHAT',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CAMBUS-OC',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CANGAWA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CANTOMUGCAD',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CANTORES',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CANTUBA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CATIGBIAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CAWAG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CRUZ',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'DAIT',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'EASTERN CABUL-AN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'HUNAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'LAPACAN NORTE',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'LAPACAN SUR',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'LUBANG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'LUSONG (PLATEAU)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MAGKAYA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MERRYLAND',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'NUEVA GRANADA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'NUEVA MONTANA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'OVERLAND',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'PANGHAGBAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'PUTING BATO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'RUFO HILL',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SWEETLAND',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'WESTERN CABUL-AN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'BICAO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'BUENOS AIRES',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CALATRAVA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'EL PROGRESO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'EL SALVADOR',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LA LIBERTAD',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LA SALVACION',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LA VICTORIA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MONTEHERMOSO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MONTESUERTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MONTESUNTING',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MONTEVIDEO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'NUEVA FUERZA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'NUEVA VIDA ESTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'NUEVA VIDA NORTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'NUEVA VIDA SUR',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TAMBO-AN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'VALLEHERMOSO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'VILLAFUERTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'VILLARCAYO',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'BACANI',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'BOGTONGBOD',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'BONTUD',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'BUACAO',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'BUANGAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CABOG',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CABOY',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CALUWASAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CANDAJEC',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'CANTOYOC',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'COMAANG',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'DANAHAO',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'LAJOG',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'MATAUB',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'NAHAWAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'POBLACION CENTRO',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'TANGARAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'TONTUNAN',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'CLARIN',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'DE LA PAZ',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'LORETO',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'MALAYO NORTE',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'MALAYO SUR',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'MONSERRAT',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'NEW LOURDES',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'PATROCINIO',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'UPPER DE LA PAZ',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'ABACA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'ABAD SANTOS',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'AGUIPO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'BAYBAYON',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CABIDIAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CAWAYANAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CONCEPCION (BANLAS)',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'DEL MAR',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'LUNGSODA-AN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'MARCELO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'MINOL',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN ROQUE (CABULAO)',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'TANGKIGAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'VALAGA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BAYONG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CAGAWASAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CANSUNGAY',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CATAGDA-AN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ESTACA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ILAUD',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'INAGHUBAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LUMBAY',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LUNDAG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PAMACSALAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'ABEHILAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BARYONG DAAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BAUNOS',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CABANUGAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CAIMBANG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CAMBANSAG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CANDUNGAO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CANSAGUE NORTE',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CANSAGUE SUR',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'CAUSWAGAN SUR',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MASONOY',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BAYONGAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BUGANG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CALUASAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CAMANAGA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CAMBANGAY NORTE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CAPAYAS',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CORAZON',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'GARCIA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'HAGBUYO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'KAGAWASAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'TOMOC',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'ADLAWAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'ANAS',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'ANOYON',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BALINGASAO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BANDERAHAN (UPPER GINOPOLAN)',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BOTONG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BUYOG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CANDUAO OCCIDENTAL',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CANDUAO ORIENTAL',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CANLUSONG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CANMANICO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CANSIBAO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CATUG-A',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CUTCUTAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'GENOVEVA',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'GINOPOLAN (GINOPOLAN PROPER)',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LA VICTORIA',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LANTANG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LIMOCON',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LOCTOB',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MARAWIS',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MAUBO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'NAILO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'OMJON',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'PANGI-AN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'POBLACION OCCIDENTAL',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'POBLACION ORIENTAL',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'SIMANG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'TAUG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'TAUSION',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'TICUM',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'ABUCAYAN NORTE',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'ABUCAYAN SUR',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'BANLASAN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'BENTIG',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'BINOGAWAN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'CABAYUGAN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'CABUDBURAN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'CALUNASAN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'CAMIAS',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'CANGUHA',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'CATMONAN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'DESAMPARADOS (POB.)',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'KAHAYAG',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'KINABAG-AN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'LABUON',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'LAWIS',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'LIBORON',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'LO-OC',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'LUCOB',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'MADANGOG',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'MAGTONGTONG',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'MANDAUG',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'MANTATAO',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'SAMPOANGON',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'SOJOTON',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'TINIBGAN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'TULTUGAN',
    },
    {
        CITY: 'CALAPE',
        BARANGAY: 'ULBUJAN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'ABIHILAN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'ANOLING',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'BOYO-AN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'CADAPDAPAN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'CAMBANE',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'CANAWA',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'CAN-OLIN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'COGTONG',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'LUAN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'LUNGSODA-AN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'MAHANGIN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'PAGAHAT',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'PANADTARAN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'PANAS',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'TAMBONGAN',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'TAWID',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'TUBOD (TRES ROSAS)',
    },
    {
        CITY: 'CANDIJAY',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'AMBUAN',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'BAANG',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'BAGTIC',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'BONGBONG',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'CAMBAILAN',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'CANDUMAYAO',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'CAUSWAGAN NORTE',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'HAGBUAYA',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'HAGUILANAN',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'KANG-IRAS',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'LIBERTAD SUR',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'LIBORON',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'MAHAYAG NORTE',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'MAHAYAG SUR',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'MAITUM',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'MANTASIDA',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'POBLACION WESTE',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'SINAKAYANAN',
    },
    {
        CITY: 'CATIGBIAN',
        BARANGAY: 'TRIPLE UNION',
    },
    {
        CITY: 'CORELLA',
        BARANGAY: 'ANISLAG',
    },
    {
        CITY: 'CORELLA',
        BARANGAY: 'CANANGCA-AN',
    },
    {
        CITY: 'CORELLA',
        BARANGAY: 'CANAPNAPAN',
    },
    {
        CITY: 'CORELLA',
        BARANGAY: 'CANCATAC',
    },
    {
        CITY: 'CORELLA',
        BARANGAY: 'PANDOL',
    },
    {
        CITY: 'CORELLA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CORELLA',
        BARANGAY: 'SAMBOG',
    },
    {
        CITY: 'CORELLA',
        BARANGAY: 'TANDAY',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'BABAG',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'CAGAWASAN',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'CAGAWITAN',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'CALUASAN',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'CAN-OLING',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'ESTACA',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'LA ESPERANZA',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'MALITBOG',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'DAGOHOY',
        BARANGAY: 'VILLA AURORA',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CABATUAN',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CANTUBOD',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CARBON',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'DAGOHOY',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'HIBALE',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'MAGTANGTANG',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'NAHUD',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'REMEDIOS',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'TABOK',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'TAMING',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'VILLA ANUNCIADO',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'BIKING',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'BINGAG',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'CATARMAN',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'MARIVELES',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'MAYACABAC',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'SAN ISIDRO (CANLONGON)',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'SONGCULAN',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'TABALONG',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'DAUIS',
        BARANGAY: 'TOTOLAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'ABIHID',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'ALEMANIA',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'BAGUHAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'BAKILID',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'BALBALAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'BAUHUGAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'BILISAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CABAGAKIAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CADAP-AGAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CAMBACOL',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CAMBAYAON',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CANHAYUPON',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CANLAMBONG',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CASINGAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'CATUGASAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'DATAG',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'GUINDAGUITAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'GUINGOYURAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'ILE',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'LAPSAON',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'LIMOKON ILAOD',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'LIMOKON ILAYA',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'LUYO',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'MALIJAO',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'OAC',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'PAGSA',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'PANGIHAWAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'PUANGYUTA',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'TANGOHAY',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'TAONGON CABATUAN',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'TAONGON CAN-ANDAM',
    },
    {
        CITY: 'DIMIAO',
        BARANGAY: 'TAWID BITAOG',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'ALEJAWAN',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'ANGILAN',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'BANGWALOG',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'CANSUHAY',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'DUAY',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'GUINSULARAN',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'ITUM',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'LANGKIS',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'LOBOGON',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'MADUA NORTE',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'MADUA SUR',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'MAMBOOL',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'MAWI',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'PAYAO',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'DUERO',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'ABIJILAN',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'BASIAO',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CAGWANG',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CALMA',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CAMBUYO',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CANAYAON EAST',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CANAYAON WEST',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CANDANAS',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CANDULAO',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CAYAM',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'CUPA',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'DATAG',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'ESTACA',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'LUNGSODAAN EAST',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'LUNGSODAAN WEST',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'MANABA',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'PASONG',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'SACAON',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'SAMPONG',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'TABUAN',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'TOGBONGON',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'ULBUJAN EAST',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'ULBUJAN WEST',
    },
    {
        CITY: 'GARCIA-HERNANDEZ',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'ALUMAR',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'BANACON',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'BUYOG',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'CABASAKAN',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'CAMPAO OCCIDENTAL',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'CAMPAO ORIENTAL',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'CANGMUNDO',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'CARLOS P. GARCIA',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'CORTE BAUD',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'HANDUMON',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'JAGOLIAO',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'JANDAYAN NORTE',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'JANDAYAN SUR',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'MAHANAY (MAHANAY ISLAND)',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'NASINGIN',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'PANDANON',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'SAGUISE',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'SALOG',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'GETAFE',
        BARANGAY: 'TULANG',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'BASDIO',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'BAYONG',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'BIABAS',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'BULAWAN',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'CABANTIAN',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'CANHAWAY',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'CANSIWANG',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'CASBU',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'CATUNGAWAN NORTE',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'CATUNGAWAN SUR',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'GUINACOT',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'GUIO-ANG',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'LOMBOG',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'MAYUGA',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'SAWANG (POB.)',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'TABAJAN (POB.)',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'TABUNOK',
    },
    {
        CITY: 'GUINDULMAN',
        BARANGAY: 'TRINIDAD',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'BAGUHAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'BAHAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'BANAHAO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'BAOGO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'BUGANG',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'CAGAWASAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'CAGAYAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'CAMBITOON',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'CANLINTE',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'CUAMING',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'DAGNAWAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'DAGOHOY',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'DAIT SUR',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'DATAG',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'HAMBONGAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'ILAUD (POB.)',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LAPACAN NORTE',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LAPACAN SUR',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LAWIS',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LILOAN NORTE',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LILOAN SUR',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LONOY CAINSICAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LONOY ROMA',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LUTAO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'LUYO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'MARIA ROSARIO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'NABUAD',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'ONDOL',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'SAA',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'TAMBOOK',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'TUNGOD',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'UBUJAN',
    },
    {
        CITY: 'INABANGA',
        BARANGAY: 'U-OG',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'ALEJAWAN',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'BALILI',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'BOCTOL',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'BUNGA ILAYA',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'BUNGA MAR',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'BUYOG',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CALABACITA',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CAMBUGASON',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CAN-IPOL',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CANJULAO',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CANTAGAY',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CANTUYOC',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CAN-UBA',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'CAN-UPAO',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'FARAON',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'KINAGBAAN',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'LACA',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'LARAPAN',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'MAYANA',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'NAATANG',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'NAUSOK',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'ODIONG',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'PAGINA',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'PANGDAN',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'POBLACION (PONDOL)',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'TEJERO',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'TUBOD MAR',
    },
    {
        CITY: 'JAGNA',
        BARANGAY: 'TUBOD MONTE',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'BONKOKAN ILAYA',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'BONKOKAN UBOS',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'CALVARIO',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'CANDULANG',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'CATUGASAN',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'CAYUPO',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'JAMBAWAN',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'LA FORTUNA',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'LOMANOY',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'MACALINGAN',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'MALINAO EAST',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'MALINAO WEST',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'NAGSULAY',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'TAUG',
    },
    {
        CITY: 'LILA',
        BARANGAY: 'TIGUIS',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'AGAPE',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'ALEGRIA NORTE',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'ALEGRIA SUR',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'BOTOC OCCIDENTAL',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'BOTOC ORIENTAL',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'CALVARIO',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'HINAWANAN',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'LAS SALINAS NORTE',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'LAS SALINAS SUR',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'PALO',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'POBLACION IBABAO',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'POBLACION UBOS',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'SAGNAP',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'TAMBANGAN',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'TANGCASAN NORTE',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'TANGCASAN SUR',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'TAYONG OCCIDENTAL',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'TAYONG ORIENTAL',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'TOCDOG DACU',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'TOCDOG ILAYA',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'VILLALIMPIA',
    },
    {
        CITY: 'LOAY',
        BARANGAY: 'YANANGAN',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'AGAPE',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'BAHIAN',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'BONBON LOWER',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'BONBON UPPER',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'CALUNASAN NORTE',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'CALUNASAN SUR',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'CAMAYAAN',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'CAMBANCE',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'CANDABONG',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'CANDASAG',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'CANLASID',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'GON-OB',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'GOTOZON',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'JIMILIAN',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'OY',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'POBLACION ONDOL',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'POBLACION SAWANG',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'QUINOGUITAN',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'UGPONG',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'VALLADOLID',
    },
    {
        CITY: 'LOBOC',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'AGSOSO',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BADBAD OCCIDENTAL',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BADBAD ORIENTAL',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BAGACAY KATIPUNAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BAGACAY KAWAYAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BAGACAY SAONG',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BAHI',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BASAC',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BASDACU',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BASDIO',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BONGCO',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CABACONGAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CABADUG',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CABUG',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CALAYUGAN NORTE',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CALAYUGAN SUR',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CAMBAQUIZ',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CAMPATUD',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANDAIGAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANHANGDON OCCIDENTAL',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANHANGDON ORIENTAL',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANIGAAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANMAAG',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANMANOC',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANSUAGWIT',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANSUBAYON',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANTAM-IS BAGO',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANTAM-IS BASLAY',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANTAONGON',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CANTUMOCAD',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CATAGBACAN HANDIG',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CATAGBACAN NORTE',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CATAGBACAN SUR',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'COGON NORTE (POB.)',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'COGON SUR',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'CUASI',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'GENOMOAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'LINTUAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'MOCPOC NORTE',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'MOCPOC SUR',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'MOTO NORTE (POB.)',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'MOTO SUR (POB.)',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'NAGTUANG',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'NAPO (POB.)',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'NUEVA VIDA',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'PANANGQUILON',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'PANTUDLAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'PIG-OT',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'PONDOL',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'QUINOBCOBAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'SONDOL',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'SONG-ON',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TANGNAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TICUGAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TIWI',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TONTONAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TUBODACU',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TUBODIO',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'TUBUAN',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'UBAYON',
    },
    {
        CITY: 'LOON',
        BARANGAY: 'UBOJAN',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'AGAHAY',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'ALIGUAY',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'ANISLAG',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'BAYACABAC',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'BOOD',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'BUSAO',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'CABAWAN',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'CANDAVID',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'DIPATLONG',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'GUIWANON',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'JANDIG',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'LAGTANGON',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'LINCOD',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'PAGNITOAN',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'PUNSOD',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'PUNTA CRUZ',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'SAN ROQUE (AGHAO)',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'TINIBGAN',
    },
    {
        CITY: 'MARIBOJOC',
        BARANGAY: 'TORIL',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'BIL-ISAN',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'BOLOD',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'DOLJO',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'LIBAONG',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'LOURDES',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'TANGNAN',
    },
    {
        CITY: 'PANGLAO',
        BARANGAY: 'TAWALA',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'AGUINING',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'BASIAO',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'BAUD',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'BAYOG',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'BOGO',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'BONBONON',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'BUTAN',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'CAMPAMANOG',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'CANMANGAO',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'GAUS',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'KABANGKALAN',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'LAPINIG',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'POPOO',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'SAGUISE',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'SAN JOSE (TAWID)',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'TILMOBO',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'TUGNAO',
    },
    {
        CITY: 'PRES.-CARLOS-P.-GARCIA',
        BARANGAY: 'VILLA MILAGROSA',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'CALANGAHAN',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'CANMANO',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'CANMAYA CENTRO',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'CANMAYA DIOT',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'DAGNAWAN',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'KABASACAN',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'KAGAWASAN',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'LANGTAD',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'LIBERTAD NORTE',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'LIBERTAD SUR',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'MANTALONGON',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SAGBAYAN SUR',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SAN VICENTE NORTE',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SAN VICENTE SUR',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAGBAYAN',
        BARANGAY: 'UBOJAN',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'BAYAWAHAN',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'CABANCALAN',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'CALINGA-AN',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'CALINGINAN NORTE',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'CALINGINAN SUR',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'CAMBAGUI',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'EWON',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'GUINOB-AN',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'LAGTANGAN',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'LICOLICO',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'LOBGOB',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SEVILLA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'ABACHANAN',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'BUGSOC',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'CAHAYAG',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'CANLANGIT',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'CANTA-UB',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'CASILAY',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'DANICOP',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'DUSITA',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'LATABAN',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'MAN-OD',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'SALVADOR',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SIERRA-BULLONES',
        BARANGAY: 'VILLA GARCIA',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'ABUCAY NORTE',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'ABUCAY SUR',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'BAHAYBAHAY',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'CAMBUAC NORTE',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'CAMBUAC SUR',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'CANAGONG',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'SIKATUNA',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'BOOL',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'BOOY',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'CABAWAN',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'DAMPAS',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'MANSASA',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'TALOTO',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'TIPTIP',
    },
    {
        CITY: 'TAGBILARAN',
        BARANGAY: 'UBUJAN',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'BALINTAWAK',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'BUSALIAN',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'CALITUBAN',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'CATABAN',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'GUINDACPAN',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'MAHANAY',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'NOCNOCAN',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SAG',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SIKATUNA',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'TANGHALIGUE',
    },
    {
        CITY: 'TALIBON',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'BANLASAN',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'BONGBONG',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'CATOOGAN',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'GUINOBATAN',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'HINLAYAGAN ILAUD',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'HINLAYAGAN ILAYA',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'KINAN-OAN',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'LA VICTORIA',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'MABUHAY CABIGOHAN',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'MAHAGBU',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'MANUEL M. ROXAS',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'SOOM',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'TAGUM NORTE',
    },
    {
        CITY: 'TRINIDAD',
        BARANGAY: 'TAGUM SUR',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'BAGONGBANWA',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'BANLASAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'BATASAN (BATASAN ISLAND)',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'BILANGBILANGAN (BILANGBILANGAN ISLAND)',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'BOSONGON',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'BUENOS AIRES',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'BUNACAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'CABULIHAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'CAHAYAG',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'CAWAYANAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'GENONOCAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'GUIWANON',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'ILIHAN NORTE',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'ILIHAN SUR',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'MACAAS',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'MATABAO',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'MOCABOC ISLAND',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'PANADTARAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'PANAYTAYON',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'PANGAPASAN (PANGAPASAN ISLAND)',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'PINAYAGAN NORTE',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'PINAYAGAN SUR',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'POOC OCCIDENTAL (POB.)',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'POOC ORIENTAL (POB.)',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'POTOHAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'TALENCERAS',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'TINANGNAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'UBAY ISLAND',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'UBOJAN',
    },
    {
        CITY: 'TUBIGON',
        BARANGAY: 'VILLANUEVA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'ACHILA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'BAY-ANG',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'BENLIW',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'BIABAS',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'BONGBONG',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'BOOD',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'BULILIS',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'CAGTING',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'CALANGGAMAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'CALIFORNIA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'CAMALI-AN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'CAMAMBUGAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'CASATE',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'CUYA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'GABI',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'GOVERNOR BOYLES',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'GUINTABO-AN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'HAMBABAURAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'HUMAYHUMAY',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'JUAGDAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'KATARUNGAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'LOMANGOG',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'LOS ANGELES',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'SENTINILA',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'SINANDIGAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'TAPAL',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'TAPON',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'TINTINAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'TIPOLO',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'TUBOG',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'TUBORAN',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'UBAY',
        BARANGAY: 'VILLA TERESITA',
    },
    {
        CITY: 'ALCOY',
        BARANGAY: 'ATABAY',
    },
    {
        CITY: 'ALCOY',
        BARANGAY: 'DAAN-LUNGSOD',
    },
    {
        CITY: 'ALCOY',
        BARANGAY: 'GUIWANG',
    },
    {
        CITY: 'ALCOY',
        BARANGAY: 'NUG-AS',
    },
    {
        CITY: 'ALCOY',
        BARANGAY: 'PASOL',
    },
    {
        CITY: 'ALCOY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALCOY',
        BARANGAY: 'PUGALO',
    },
    {
        CITY: 'ALCOY',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'ANGILAN',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'BOJO',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'KANDINGAN',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'KANTABOGON',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'KAWASAN',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'OLANGO',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'PUNAY',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'SAKSAK',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'TAMPA-AN',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'TOYOKON',
    },
    {
        CITY: 'ALOGUINSAN',
        BARANGAY: 'ZARAGOSA',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'ALAMBIJUD',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'ANAJAO',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'APO',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'BALAAS',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'BALISONG',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'BINLOD',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'BOGO',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'BUG-OT',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'BULASA',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'BUTONG',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'CALAGASAN',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'CANBANTUG',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'CANBANUA',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'CANSUJE',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'CAPIO-AN',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'CASAY',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'CATANG',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'COLAWIN',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'CONALUM',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'GUIWANON',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'GUTLANG',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'JAMPANG',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'JOMGAO',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'LAMACAN',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'LANGTAD',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'LANGUB',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'LAPAY',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'LENGIGON',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'LINUT-OD',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'MABASA',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'MANDILIKIT',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'MOMPELLER',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'PANADTARAN',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'SUMAGUAN',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'TABAYAG',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'TALAGA',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'TALAYTAY',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'TALO-OT',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'TIGUIB',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'TULANG',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'TULIC',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'UBAUB',
    },
    {
        CITY: 'ARGAO',
        BARANGAY: 'USMAD',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'AGBANGA',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'AGTUGOP',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'BAIRAN',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'BAYE',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'BOG-O',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'KALUANGAN',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'LANGUB',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'LOOC NORTE',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'LUNAS',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'MAGCALAPE',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'MANGUIAO',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'NEW BAGO',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'OWAK',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'SAKSAK',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'TAG-AMAKAN',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'TAGBUBONGA',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'TUBIGAGMANOK',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'ASTURIAS',
        BARANGAY: 'UBOGON',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'ALAWIJAO',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'BALHAAN',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'BANHIGAN',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'BASIAO',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'BUGAS',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'CALANGCANG',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'CANDIIS',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'DAGATAN',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'DOBDOB',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'GINABLAN',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'LAMBUG',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'MALABAGO',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'MALHIAO',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'MANDUYONG',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'MATUTINAO',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'SANLAGAN',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'SANTICON',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'SOHOTON',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'SULSUGAN',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'TALAYONG',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'TIGUIB',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'BADIAN',
        BARANGAY: 'ZARAGOSA',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'ABUCAYAN',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'ALIWANAY',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'ARPILI',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'BALIWAGAN (POB.)',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'BAYONG',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'BUANOY',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'CABAGDALAN',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'CABASIANGAN',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'CAMBUHAWE',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'CANSOMOROY',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'CANTIBAS',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'CANTUOD',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'DUANGAN',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'GAAS',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'GINATILAN',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'HINGATMONAN',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'LAMESA',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'LIKI',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'LUCA',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'MATUN-OG',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'PONDOL',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'PRENZA',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'SANTA CRUZ-SANTO NINO (POB.)',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'SANTA CRUZ-SANTO NIÑO (POB.)',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'SINGSING',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'SUNOG',
    },
    {
        CITY: 'BALAMBAN',
        BARANGAY: 'VITO',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'ATOP-ATOP',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'BAIGAD',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'BANTIGUE (POB.)',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'BAOD',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'BINAOBAO (POB.)',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'BOTIGUES',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'DOONG',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'GUIWANON',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'HILOTONGAN',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'KABAC',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'KABANGBANG',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'KAMPINGGANON',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'KANGKAIBE',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'LIPAYRAN',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'LUYONGBAYBAY',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'MOJON',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'OBO-OB',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'PATAO',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'PUTIAN',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'SILLON',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'SUBA (POB.)',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'SULANGAN',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'SUNGKO',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'TAMIAO',
    },
    {
        CITY: 'BANTAYAN',
        BARANGAY: 'TICAD (POB.)',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'AZUCENA',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'BAGAKAY',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'BALAO',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'BOLOCBOLOC',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'BUDBUD',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'BUGTONG KAWAYAN',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'CABCABAN',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'CAGAY',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'CAMPANGGA',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'CANDUGAY',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'DAKIT',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'GILOCTOG',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'GIWANON',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'GUIBUANGAN',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'GUNTING',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'HILASGASAN',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'JAPITAN',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'KALUBIHAN',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'KANGDAMPAS',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'LUHOD',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'LUPO',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'LUYO',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'MAGHANOY',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'MAIGANG',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'MALOLOS',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'MANTALONGON',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'MANTAYUPAN',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'MAYANA',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'MINOLOS',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'NABUNTURAN',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'NASIPIT',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'PANCIL',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'PARIL',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'PATUPAT',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'SAYAW',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'TAL-OT',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'BARILI',
        BARANGAY: 'VITO',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'ANONANG NORTE',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'ANONANG SUR',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'BINABAG',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'BUNGTOD (POB.)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'CARBON (POB.)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'CAYANG',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'COGON (POB.)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'DAKIT',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'DON PEDRO RODRIGUEZ',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'GAIRAN',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'LA PURISIMA CONCEPCION (POB.)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'LOURDES (POB.)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'MALINGIN',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'MARANGOG',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'NAILON',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'ODLOT',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'PANDAN (PANDAN HEIGHTS)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'POLAMBATO',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'SAMBAG (POB.)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'SANTO ROSARIO (POB.)',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'SIOCON',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'SUDLONON',
    },
    {
        CITY: 'BOGO',
        BARANGAY: 'TAYTAYAN',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'ARBOR',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'BACLAYAN',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'EL PARDO',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'GRANADA',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'LOWER BECERRIL',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'LUNOP',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'SOUTH GRANADA',
    },
    {
        CITY: 'BOLJOON',
        BARANGAY: 'UPPER BECERRIL',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'BILI',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'BINGAY',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'BONGDO',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'BONGDO GUA',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'BONGOYAN',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'CADARUHAN',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'CAJEL',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'CAMPUSONG',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'CLAVERA',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'DON GREGORIO ANTIGUA (TAYTAYAN)',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'LAAW',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'LUGO',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'MANAGASE',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'SAGAY',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'TABUNAN',
    },
    {
        CITY: 'BORBON',
        BARANGAY: 'TAGNUCAN',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'BOLINAWAN',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'CALIDNGAN',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'CAN-ASUJAN',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'LIBURON',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'OCANA',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'PERRELOS',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'TUYOM',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'CARCAR',
        BARANGAY: 'VALLADOLID',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'AGSUWAO',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'AMANCION',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'ANAPOG',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'BACTAS',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'BINONGKALAN',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'BONGYAS',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'CABUNGAAN',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'CAMBANGKAYA',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'CAN-IBUANG',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'CATMONDAAN',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'CORAZON (POB.)',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'DUYAN',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'FLORES (POB.)',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'GINABUCAN',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'MACAAS',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'PANALIPAN',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'SAN JOSE POB. (CATADMAN)',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'TABILI',
    },
    {
        CITY: 'CATMON',
        BARANGAY: 'TINABYONAN',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'CABIL-ISAN',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'CANDABONG',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'ALCANTARA',
        BARANGAY: 'SALAGMAYA',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'COMPOSTELA',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'LEGASPI',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'LEPANTO',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'MADRIDEJOS',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'MONTPELLER',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'BARING',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CANTIPAY',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CANTUKONG',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CANTUMOG',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CAURASAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'COGON EAST',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'COGON WEST',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CORTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'DAWIS NORTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'DAWIS SUR',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'HAGNAYA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LANIPGA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LIBORON',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LOWER NATIMAO-AN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'LUYANG',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'PUENTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'SAC-ON',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TRIUMFO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'UPPER NATIMAO-AN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'ADLAON',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'AGSUNGOT',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'APAS',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BABAG',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BACAYAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BASAK PARDO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BASAK SAN NICOLAS',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BINALIW',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BUDLA-AN (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BUHISAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BULACAO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BUOT-TAUP PARDO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'BUSAY (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'CALAMBA',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'CAMBINOCOT',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'CAMPUTHAW (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'CAPITOL SITE (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'CARRETA',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'COGON PARDO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'COGON RAMOS (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'DAY-AS',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'DULJO (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'ERMITA (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'GUBA',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'HIPPODROMO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'INAYAWAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'KALUBIHAN (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'KALUNASAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'KAMAGAYAN (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'KASAMBAGAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'KINASANG-AN PARDO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'LABANGON',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'LAHUG (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'LOREGA (LOREGA SAN MIGUEL)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'LUSARAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'LUZ',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'MABOLO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'MALUBOG',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'MAMBALING',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'NORTH RECLAMATION AREA',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PAHINA CENTRAL (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PAHINA SAN NICOLAS',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PAMUTAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PARDO (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PARI-AN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PARIL',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PASIL',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PIT-OS',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PULANGBATO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PUNG-OL-SIBUGAY',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'PUNTA PRINCESA',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'QUIOT PARDO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SAMBAG I (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SAMBAG II (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SAN NICOLAS CENTRAL',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SAN ROQUE (CIUDAD)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SAPANGDAKU',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SAWANG CALERO (POB.)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SINSIN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SIRAO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SUBA POB. (SUBA SAN NICOLAS)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SUDLON I',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'SUDLON II',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'T. PADILLA',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'TABUNAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'TAGBAO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'TALAMBAN',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'TAPTAP',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'TEJERO (VILLA GONZALO)',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'TISA',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'TO-ONG PARDO',
    },
    {
        CITY: 'CEBU',
        BARANGAY: 'ZAPATERA',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'BAGALNGA',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'BULUANG',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'CAMBAYOG',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'CANAMUCAN',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'ESTACA',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'LUPA',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'MAGAY',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'MULAO',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'PANANGBAN',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'TAG-UBE',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'TAMIAO',
    },
    {
        CITY: 'COMPOSTELA',
        BARANGAY: 'TUBIGAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'CALERO',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'CATARMAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'COTCOT',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'JUBAY',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'LATABAN',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'MULAO',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'TABLA',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'TAYUD',
    },
    {
        CITY: 'LILOAN',
        BARANGAY: 'YATI',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'ALFACO',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'BAIRAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'BALIRONG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CABUNGAHAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CANTAO-AN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'CENTRAL POBLACION',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'COLON',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'EAST POBLACION',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'INAYAGAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'INOBURAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'JAGUIMIT',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'LANAS',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'LANGTAD',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'LUTAC',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'MAYANA',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'NAALAD',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'PANGDAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TAGJAGUIMIT',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TANGKE',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TINAAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'TUYAN',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'ULING',
    },
    {
        CITY: 'NAGA',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CAWIT',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'LOWER POBLACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MOABOG',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MONTSERRAT',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'UPPER POBLACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BALUNGAG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CABATBATAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'GREENHILLS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LANTAWAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LIBURON',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MAGSICO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'NORTHERN POBLACION',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PANADTARAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PITALO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANGAT',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TABIONAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TANANAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TINUBDAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TONGGO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'HIMENSULAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'MONTEALEGRE',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'NORTHERN POBLACION',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SANGAT',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SONOG',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SOUTHERN POBLACION',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'UNIDOS',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'WESTERN POBLACION',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'ANAPOG',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'ARGAWANON',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BAGTIC',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BANCASAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BATAD',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BUSOGON',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CALAMBUA',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CANAGAHAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'GAWAYGAWAY',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'HAGNAYA',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'KAYAM',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'KINAWAHAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'LAMBUSAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'LAWIS',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'LIBAONG',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'LUYANG',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'MANO',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'SAB-A',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'TACUP',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'TAMBONGON',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'TO-ONG',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'BALIDBID',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'HAGDAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'HILANTAGAAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'KINATARKAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'LANGUB',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'MARICABAN',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'OKOY',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'POOC',
    },
    {
        CITY: 'SANTA-FE',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'AMPONGOL',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'BAGAKAY',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'BAGATAYAM',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'BAWO',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'CABALAWAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'CALUMBOYAN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'DAKIT',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'DAMOLOG',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'IBABAO',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'LIKI',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'LUBO',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'NAHUS-AN',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'PANSOY',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'TABUNOK',
    },
    {
        CITY: 'SOGOD',
        BARANGAY: 'TAKAY',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'BIASONG',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'BULACAO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CADULAWAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CAMP IV',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CANSOJONG',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'DUMLOG',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'JACLUPAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'LAGTANG',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'LAWAAN I',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'LAWAAN II',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'LAWAAN III',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'MAGHAWAY',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'MANIPIS',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'POOC',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'TABUNOC',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'TANGKE',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'TAPUL',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'AMATUGAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'APALAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BAGASAWE',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BAKYAWAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BANGKITO',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BARANGAY VII (POB.)',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BARANGAY VIII (POB.)',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'BULWANG',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'CARMELO',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'COLONIA',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'DAAN LUNGSOD',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'FORTALIZA',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'GA-ANG',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'GIMAMA-A',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'JAGBUAYA',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KABANGKALAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KABKABAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KAGBA-O',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KALANGAHAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KAMANSI',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KAMPOOT',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KAN-AN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KANLUNSING',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KANSI',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'KAORASAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'LIBO',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'LUSONG',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MACUPA',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MAG-ALWA',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MAG-ANTOY',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MAG-ATUBANG',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MAGHAN-AY',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MANGGA',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MARMOL',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MOLOBOLO',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'MONTEALEGRE',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'PUTAT',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'SANDAYONG',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'SIOTES',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'SUMON',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'TOMINJAO',
    },
    {
        CITY: 'TUBURAN',
        BARANGAY: 'TOMUGPA',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'CALMANTE',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'DAAN SECANTE',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'GENERAL',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'MCARTHUR',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'NORTHERN POBLACION',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'PUERTOBELLO',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'SANTANDER',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'SECANTE BAG-O',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'SOUTHERN POBLACION',
    },
    {
        CITY: 'TUDELA',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'CANSAGA',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'CASILI',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'DANGLAG',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'GARING',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'JUGAN',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'LAMAC',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'LANIPGA',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'PANAS',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'PANOYPOY',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'POBLACION OCCIDENTAL',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'POBLACION ORIENTAL',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'POLOG',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'PULPOGAN',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'SACSAC',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'TAYUD',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'TILHAONG',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'TOLOTOLO',
    },
    {
        CITY: 'CONSOLACION',
        BARANGAY: 'TUGBONGAN',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'BANGBANG',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'BUAGSONG',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'CATARMAN',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'DAPITAN',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'DAY-AS',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'GABI',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'GILUTONGAN',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'IBABAO',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'PILIPOG',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CORDOVA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'AGUHO',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'BAGAY',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'BAKHAWAN',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'BATERIA',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'BITOON',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'CALAPE',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'CARNAZA',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'DALINGDING',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'LOGON',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'MALBAGO',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'MALINGIN',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'MAYA',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'PAYPAY',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'TAPILON',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'TINUBDAN',
    },
    {
        CITY: 'DAANBANTAYAN',
        BARANGAY: 'TOMINJAO',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'ABLAYAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'BABAYONGAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'BANHIGAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'BULAK',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'CALERIOHAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'CALIONGAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'CASAY',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'CATOLOHAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'CORO',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'DUGYAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'DUMALAN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'JOLOMAYNON',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'LANGKAS',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'LUMBANG',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'MALONES',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'MALORAY',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'MANANGGAL',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'MANLAPAY',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'MANTALONGON',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'NALHUB',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'OBO',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'OBONG',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'PANAS',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'SACSAC',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'SALUG',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'TAPUN',
    },
    {
        CITY: 'DALAGUETE',
        BARANGAY: 'TUBA',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'BALIANG',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'BINALIW',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CABUNGAHAN',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CAGAT-LAMAC',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CAHUMAYAN',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CAMBANAY',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'CAMBUBHO',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'COGON-CRUZ',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'DANASAN',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'DUNGGA',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'DUNGGOAN',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'GUINACOT',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'GUINSAY',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'IBO',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'LANGOSIG',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'LICOS',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'MAGTAGOBTOB',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'MALAPOC',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'MANLAYAG',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'MANTIJA',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'MASABA',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'MASLOG',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'OGUIS',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'QUISOL',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SACSAC',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SANDAYONG NORTE',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SANDAYONG SUR',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SANTICAN',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SIBACAN',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'TABOC',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'TOGONON',
    },
    {
        CITY: 'DANAO',
        BARANGAY: 'TUBURAN SUR',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'BALAYGTIKI',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'BITOON',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'BULAK',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'BULLOGAN',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'CALABOON',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'CAMBOANG',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'CANDABONG',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'COTCOTON',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'DOLDOL',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'ILAYA (POB.)',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KABALAASNAN',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KABATBATAN',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KAMBANOG',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KANG-ACTOL',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KANGHALO',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KANGHUMAOD',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KANGUHA',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KANTANGKAS',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KANYUKO',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'KOLABTINGON',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'LAMAK',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'MANLAPAY',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'MASA',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'MATALAO',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'PACULOB',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'PANLAAN',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'POBLACION CENTRAL',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'POBLACION LOOC',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'POBLACION SIMA',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'TANGIL',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'TAPON',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'TUBOD-BITOON',
    },
    {
        CITY: 'DUMANJUG',
        BARANGAY: 'TUBOD-DUGOAN',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'ANAO',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'CAGSING',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'CALABAWAN',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'CAMBAGTE',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'CAMPISONG',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'CANORONG',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'GUIWANON',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'MALATBO',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'MANGACO',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'SALAMANCA',
    },
    {
        CITY: 'GINATILAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'AGUS',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'BABAG',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'BANKAL',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'BARING',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'BUAYA',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'CALAWISAN',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'CANJULAO',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'CAUBIAN',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'CAWHAGAN',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'CAW-OY',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'GUN-OB',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'IBO',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'MACTAN',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'MARIBAGO',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'MARIGONDON',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'PAJAC',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'PANGAN-AN',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'PUNTA ENGANO',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'PUNTA ENGAÑO',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'PUSOK',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'SUBABASBAS',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'TALIMA',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'TINGO',
    },
    {
        CITY: 'LAPU-LAPU',
        BARANGAY: 'TUNGASAN',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'BUNAKAN',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'KANGWAYAN',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'KAONGKOD',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'KODIA',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'MAALAT',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'MALBAGO',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'MANCILANG',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'TABAGAK',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'TALANGNAN',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'TARONG',
    },
    {
        CITY: 'MADRIDEJOS',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'ARMENA (CANSILONGAN)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'CERDENA (ANSAN)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'LABRADOR (BULOD)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'LOMBO',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'MAHANLUD',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'MINDANAO (PAJO)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'MONTANEZA (INAMLANG)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'MONTAÑEZA (INAMLANG)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'SALMERON (BULAK)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'SORSOGON (BALIMAYA)',
    },
    {
        CITY: 'MALABUYOC',
        BARANGAY: 'TOLOSA (CALATAGAN)',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'BAKILID',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'CABANCALAN',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'CAMBARO',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'CANDUMAN',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'CASILI',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'CASUNTINGAN',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'CUBACUB',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'GUIZO',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'IBABAO-ESTANCIA',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'JAGOBIAO',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'LABOGON',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'MAGUIKAY',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'MANTUYONG',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'OPAO',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'PAGSABUNGAN',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'PAKNA-AN',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'SUBANGDAKU',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'TABOK',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'TAWASON',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'TINGUB',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'TIPOLO',
    },
    {
        CITY: 'MANDAUE',
        BARANGAY: 'UMAPAD',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'CANHABAGAT',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'CAPUTATAN NORTE',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'CAPUTATAN SUR',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'CURVA',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'DAANLUNGSOD',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'DALINGDING SUR',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'DAYHAGON',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'DON VIRGILIO GONZALES',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'GIBITNGIL',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'KAWIT',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'LAMINTAK NORTE',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'LAMINTAK SUR',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'LUY-A',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'MAHARUHAY',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'MAHAWAK',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'PANUGNAWAN',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MEDELLIN',
        BARANGAY: 'TINDOG',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'CADULAWAN',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'CALAJO-AN',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'CAMP 7',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'CAMP 8',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'CUANOS',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'GUINDARUHAN',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'MANDUANG',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'PAKIGNE',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'POBLACION WARD I',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'POBLACION WARD II',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'POBLACION WARD III',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'POBLACION WARD IV',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'TULAY',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'TUNGHAAN',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'TUNGKIL',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'TUNGKOP',
    },
    {
        CITY: 'MINGLANILLA',
        BARANGAY: 'VITO',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'AGBALANGA',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'BALA',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'BALABAGON',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'BASDIOT',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'BATADBATAD',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'BUGHO',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'BUGUIL',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'SAAVEDRA',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'TOMONOY',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'TUBLE',
    },
    {
        CITY: 'MOALBOAL',
        BARANGAY: 'TUNGA',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'ALO',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'BANGCOGON',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'CANANG',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'CANANGCA-AN',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'CANSALO-AY',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'CAN-UKBAN',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'DAANLUNGSOD',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'GAWI',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'HAGDAN',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'LAGUNDE',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'LUKA',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'MANLUM',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'NUEVA CACERES',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'PUNGTOD',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'OSLOB',
        BARANGAY: 'TUMALOG',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'ANISLAG',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'ANOPOG',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'BINABAG',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'BUHINGTUBIG',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'BUTONG',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'CABIANGON',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'CAMUGAO',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'DUANGAN',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'GUIMBAWIAN',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'LAMAC',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'LUT-OD',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'MANGOTO',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'OPAO',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'PANDACAN',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'PUNOD',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'SACSAC',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'SAMBAGON',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'SIBAGO',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'TAJAO',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'TANGUB',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'TANIBAG',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'TUPAS',
    },
    {
        CITY: 'PINAMUNGAHAN',
        BARANGAY: 'TUTAY',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'ADELA',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'ALTAVISTA',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'CAGCAGAN',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'CANSABUSAB',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'DAAN PAZ',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'EASTERN POBLACION',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'PAGSA',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'PAZ',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'TEGUIS',
    },
    {
        CITY: 'PORO',
        BARANGAY: 'WESTERN POBLACION',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'BUTONG',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'CAN-ABUHON',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'CANDULING',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'CANSALONOY',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'CANSAYAHON',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'LANGIN',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'LIBO-O',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'MALALAY',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'PALANAS',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'TUPAS',
    },
    {
        CITY: 'RONDA',
        BARANGAY: 'VIVE',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'BULANGSURAN',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'CALATAGAN',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'CAMBIGONG',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'CAMBUROY',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'CANORONG',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'COLASE',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'DALAHIKAN',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'JUMANGPAS',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'MONTEVERDE',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'SAMBOAN',
        BARANGAY: 'TANGBO',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'BUNLAN',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'CABUTONGAN',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'CANDAMIANG',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'CANLUMACAD',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'LILOAN',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'LIP-TONG',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'PASIL',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTANDER',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'ABUGON',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'BAE',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'BAHAY',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'BANLOT',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'CAGAY',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'CAN-AGA',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'CANDAGUIT',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'CANTOLAROY',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'DUGOAN',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'GUIMBANGCO-AN',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'LAMACAN',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'LIBO',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'LINDOGON',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'MAGCAGONG',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'MANATAD',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'MANGYAN',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'PAPAN',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'SAYAO',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'SIMALA',
    },
    {
        CITY: 'SIBONGA',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'CADUAWAN',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'CAMOBOAN',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'CANAOCANAO',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'COMBADO',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'DAANTABOGON',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'KAL-ANAN',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'LABANGON',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'LOONG',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'MABULI',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'MANAGASE',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'MANLAGTANG',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'MASLOG',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'MUABOG',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'PIO',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'SALAG',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'SAMBAG',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'SOMOSA',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'TABA-AO',
    },
    {
        CITY: 'TABOGON',
        BARANGAY: 'TAPUL',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'BONGON',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'DALID',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'KANLIM-AO',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'KANLUHANGON',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'KANTUBAON',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'MABUNAO',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'MARAVILLA',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'OLIVO',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'TABUNOK',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'TIGBAWAN',
    },
    {
        CITY: 'TABUELAN',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'AWIHAO',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'BAGAKAY',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'BIGA',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'BULONGAN',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'CABITOONAN',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'CALONGCALONG',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'CAMBANG-UG',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'CAMP 8',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'CANLUMAMPAO',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'CANTABACO',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'CAPITAN CLAUDIO',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'DAANGLUNGSOD',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'DON ANDRES SORIANO (LUTOPAN)',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'DUMLOG',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'GEN. CLIMACO (MALUBOG)',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'IBO',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'JUAN CLIMACO',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'JUAN CLIMACO SR. (MAGDUGO)',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'LANDAHAN',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'LOAY',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'LURAY II',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'MATAB-ANG',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'MEDIA ONCE',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'PANGAMIHAN',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'POOG',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'PUTINGBATO',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'SAGAY',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'SAM-ANG',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'SANGI',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'SANTO NINO (MAINGGIT)',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'SANTO NIÑO (MAINGGIT)',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'SUBAYON',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'TALAVERA',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'TOLEDO',
        BARANGAY: 'TUNGKAY',
    },
    {
        CITY: 'AMLAN',
        BARANGAY: 'BIO-OS',
    },
    {
        CITY: 'AMLAN',
        BARANGAY: 'JANTIANON',
    },
    {
        CITY: 'AMLAN',
        BARANGAY: 'JUGNO',
    },
    {
        CITY: 'AMLAN',
        BARANGAY: 'MAG-ABO',
    },
    {
        CITY: 'AMLAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'AMLAN',
        BARANGAY: 'SILAB',
    },
    {
        CITY: 'AMLAN',
        BARANGAY: 'TAMBOJANGIN',
    },
    {
        CITY: 'AMLAN',
        BARANGAY: 'TANDAYAG',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'AMDUS',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'ANIBONG',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'ATABAY',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'AWA-AN',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'BAN-BAN',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'CALAGCALAG',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'CANDANA-AY',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'CAROL-AN',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'GOMENTOC',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'INACBAN',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'INIBAN',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'JANDALAMANON',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'KILABAN',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'LAMIGAN',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'MAASLUM',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'MABATO',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'MANOGTONG',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'NABHANG',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'TAMBO',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'TAMPOCON I',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'TAMPOCON II',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'TIBYAWAN',
    },
    {
        CITY: 'AYUNGON',
        BARANGAY: 'TIGUIB',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'BALAYAGMANOK',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'BUNTIS',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'BUNTOD',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'CALANGAG',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'COMBADO',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'DOLDOL',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'ISUGAN',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'LIPTONG',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'LUTAO',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'MAGSUHOT',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'MALABAGO',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'MAMPAS',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'SACSAC',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'SULODPAN',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'TIMBANGA',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'TIMBAO',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'BACONG',
        BARANGAY: 'WEST POBLACION',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'BINOHON',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CABANLUTAN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CALASGA-AN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CAMBAGAHAN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CAMBAGUIO',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CAMBANJAO',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CAMBUILAO',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CANLARGO',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CAPINAHAN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'DANSULAN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'HANGYAD',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'KATACGAHAN (TACGAHAN)',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'LO-OC',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'MABUNAO',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'MANLIPAC',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'MANSANGABAN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'OKIOT',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'OLYMPIA',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'PANALA-AN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'PANAM-ANGAN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'SAB-AHAN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'TAGPO',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'TALUNGON',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'TAMISU',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'TAMOGONG',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'TANGCULOGAN',
    },
    {
        CITY: 'BAIS',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'ACTIN',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'BAL-OS',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'BONGALONAN',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'CABALAYONGAN',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'CABATUANAN',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'LINANTAYAN',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'MAGLINAO',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'NAGBO-ALAO',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'OLANDAO',
    },
    {
        CITY: 'BASAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'ALI-IS',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'BANAYBANAY',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'BOYCO',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'BUGAY',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'CANSUMALIG',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'DAWIS',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'KALAMTUKAN',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'KALUMBOYAN',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'MALABUGAS',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'MANDU-AO',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'MANINIHON',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'MINABA',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'PAGATBAN',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'SUBA (POB.)',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'TABUAN',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'TAYAWAN',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'TINAGO (POB.)',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'UBOS (POB.)',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'VILLAREAL',
    },
    {
        CITY: 'BAYAWAN',
        BARANGAY: 'VILLASOL (BATO)',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'ATOTES',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'BATANGAN',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'CABCABAN',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'CABUGAN',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'CAMUDLAS',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'CANLUTO',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'DANAWAN',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'DOMOLOG',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'MALAGA',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'MANSEJE',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'MATOBATO',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'NAGCASUNOG',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'NALUNDAN',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'PANGALAYCAYAN',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'PENAHAN',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'POBLACION (PAYABON)',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'SALONG',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'TINAOGAN',
    },
    {
        CITY: 'BINDOY',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'BAYOG',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'BINALBAGAN',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'BUCALAN (EAST BUDSALAN)',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'BUDLASAN (WEST BUDLASAN)',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'LINOTHANGAN',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'LUMAPAO',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'MABIGO (POB.)',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'MALAIBA',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'MASULOG',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'NINOY AQUINO',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'PANUBIGAN',
    },
    {
        CITY: 'CANLAON',
        BARANGAY: 'PULA',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'ANAHAWAN',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'APO ISLAND',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'BASLAY',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'BATUHON DACU',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'BOLOC-BOLOC',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'BULAK',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'CASILE',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'LIPAYO',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'MAAYONGTUBIG',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'MAG-ASO',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'MALONGCAY DACU',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'MASAPLOD NORTE',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'MASAPLOD SUR',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'PANUBTUBAN',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'TUGAWE',
    },
    {
        CITY: 'DAUIN',
        BARANGAY: 'TUNGA-TUNGA',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'BAJUMPANDAN',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'BANILAD',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'BATINGUEL',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'BUNAO',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'CADAWINONAN',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'CALINDAGAN',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'CAMANJAC',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'CANDAU-AY',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'CANTIL-E',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'DARO',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'JUNOB',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'MANGNAO-CANAL',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'MOTONG',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'PIAPI',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'POBLACION NO. 1 (BARANGAY 1)',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'POBLACION NO. 2 (BARANGAY 2)',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'POBLACION NO. 3 (BARANGAY 3)',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'POBLACION NO. 4 (BARANGAY 4)',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'POBLACION NO. 5 (BARANGAY 5)',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'POBLACION NO. 6 (BARANGAY 6)',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'POBLACION NO. 7 (BARANGAY 7)',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'POBLACION NO. 8 (BARANGAY 8)',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'PULANTUBIG',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'TABUCTUBIG',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'TACLOBO',
    },
    {
        CITY: 'DUMAGUETE',
        BARANGAY: 'TALAY',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'BAKID',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'BANWAQUE',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'BINOBOHAN',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'BULADO',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'CALAMBA',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'CALUPA-AN',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'HIBAIYO',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'HILAITAN',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'HINAKPAN',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'HUMAYHUMAY',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'KAGAWASAN',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'LINANTUYAN',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'LUZ',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'MABUNGA',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'MALUSAY',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'MANIAK',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'MCKINLEY',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'NAGSAHA',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'PADRE ZAMORA',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'PLAGATASANON',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'PLANAS',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'SANDAYAO',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'TACPAO',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'TINAYUNAN BEACH',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'TINAYUNAN HILL',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'TRINIDAD',
    },
    {
        CITY: 'GUIHULNGAN',
        BARANGAY: 'VILLEGAS',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'AGLAHUG',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'AGUTAYON',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'APANANGON',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'BAE',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'BALA-AS',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'BANGCAL',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'BANOG',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'BUTO',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'CABANG',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'CAMANDAYON',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'CANGHARAY',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'CANLAHAO',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'DAYOYO',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'ELI',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'LACAON',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'MAHANLUD',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'MALABAGO',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'MAMBAID',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'MONGPONG',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'OWACAN',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'PACUAN',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'PANGLAYA-AN',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'POLOPANTAO',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'SAMPINITON',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'TALAMBAN',
    },
    {
        CITY: 'JIMALALUD',
        BARANGAY: 'TAMAO',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'ABIS',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'AREBASORE',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'BAGTIC',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'BARRAS',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'BULIBULIHAN',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'BULWANG',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'CAMPANUN-AN',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'CANGGOHOB',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'CANSAL-ING',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'DAGBASAN',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'DAHILE',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'HAGTU',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'HIMOCDONGON',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'INAPOY',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'LAMDAS',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'LUMBANGAN',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'LUYANG',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'MANLINGAY',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'MAYAPOSI',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'NAPASU-AN',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'NEW NAMANGKA',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'OLD NAMANGKA',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'PANDANON',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'PANIABONAN',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'SAMAC',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'TADLONG',
    },
    {
        CITY: 'MABINAY',
        BARANGAY: 'TARA',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'ALANGILANAN',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'BAGTIC',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'BALAAS',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'BANTOLINAO',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'BOLISONG',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'BUTONG',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'CAMPUYO',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'CANDABONG',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'DUNGO-AN',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'LAMOGONG',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'LIBJO',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'MAASLUM',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'MANDALUPANG',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'PANCIAO',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'SAC-SAC',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'SUNDO-AN',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'TANGLAD',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'MANJUYOD',
        BARANGAY: 'TUPAS',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'ANINIAW',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'AYA',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'BAGTIC',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'BIGA-A',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'BUSILAK',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'CANGABO',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'CANTUPA',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'ELECIA (TALOSTOS)',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'ELI',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'GUIHOB',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'KANSUMANDIG',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MAMBULOD',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MANDAPATON',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MANGHULYAWON',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MANLUMINSAG',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MAPALASAN',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MARAGONDONG',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'MARTILO',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'NASUNGAN',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'PACUAN',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'PANGCA',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'PISONG',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'SOLONGON',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'TALA-ON',
    },
    {
        CITY: 'LA-LIBERTAD',
        BARANGAY: 'TALAYONG',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'ABANTE',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BALAYONG',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'BANAWE',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'CALICANAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'DATAGON',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'INAWASAN',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'MAGSUSUNOG',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'MALALANGSI',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'MAMBURAO',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'MANGOTO',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SANTA AGUEDA',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'SIMBORIO',
    },
    {
        CITY: 'PAMPLONA',
        BARANGAY: 'YUPISAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BASIAO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CAMBALOCTOT',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CANCAWAS',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'JANAYJANAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'JILOCON',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'NAIBA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SENORA ASCION (CALO)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SIAPO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TAMPI',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'TAPON NORTE',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'ALANGILAN',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'AMIO',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'CAIGANGAN',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'CARANOCHE',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'CAWITAN',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'KABULACAN',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'MANALONGON',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'MANSAGOMAYON',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'MILAGROSA',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'NAGBALAYE',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'NAGBINLOD',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'OBAT',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'TALALAK',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'APOLONG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BALABAG EAST',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BALABAG WEST',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BALAYAGMANOK',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BALILI',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BALUGO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BONG-AO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'BONGBONG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CAIDIOCAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CALAYUGAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'CAMBUCAD',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'DOBDOB',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'JAWA',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LIPTONG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'LUNGA',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MALABO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MALAUNAY',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'MAMPAS',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'PALINPINON',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'PUHAGAN',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'PULANGBATO',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'SAGBANG',
    },
    {
        CITY: 'VALENCIA',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'BALOLONG',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'BINO-ONGAN',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'BITAUG',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'BOLOT',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'CAMOGAO',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'CANGMANGKI',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'LIBO',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'LOMANGCAPAN',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'LOTLOTON',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'MANAN-AO',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'OLAVE',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'PARIAN',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ENRIQUE-VILLANUEVA',
        BARANGAY: 'TULAPOS',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'BALOLANG',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'BASAC',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'BINTANGAN',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'BONTOD',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CABULIHAN',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CALUNASAN',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CANDIGUM',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CANG-ALLAS',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CANG-APA',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CANGBAGSA',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CANGMALALAG',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CANLAMBO',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CANLASOG',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'CATAMBOAN',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'HELEN (DATAG)',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'NONOC',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'NORTH POBLACION',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'PONONG',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'SANDUGAN',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'SOUTH POBLACION',
    },
    {
        CITY: 'LARENA',
        BARANGAY: 'TACULING',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'CAMPALANAS',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'CANGCLARAN',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'CANGOMANTONG',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'CAPALASANAN',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'CATAMBOAN (POB.)',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'GABAYAN',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'KIMBA',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'KINAMANDAGAN',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'LOWER CABANGCALAN',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'NAGERONG',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'PO-O',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'SIMACOLONG',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'TAGMANOCAN',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'TALAYONG',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'TIGBAWAN (POB.)',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'TIGNAO',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'UPPER CABANGCALAN',
    },
    {
        CITY: 'LAZI',
        BARANGAY: 'YTAYA',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'BOGO',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'CABAL-ASAN',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'CALUNASAN',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'CANDAPING A',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'CANDAPING B',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'CANTAROC A',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'CANTAROC B',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'CANTUGBAS',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'LICO-AN',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'LILO-AN',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'LOGUCAN',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'LOOC',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'MINALULAN',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'NABUTAY',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'OLANG',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'PISONG A',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'PISONG B',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'SAGUING',
    },
    {
        CITY: 'MARIA',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'BOLOS',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CAIPILAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CAITICAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CALALINAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANAL',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANDANAY NORTE',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANDANAY SUR',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANG-ADIENG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANG-AGONG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANG-ALWANG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANG-ASA',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANG-ATUYOM',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANGHUNOGHUNOG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANG-INTE',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANG-ISAD',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANGMATNOG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANGMOHAO',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CANTABON',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'CATICUGAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'DUMANHOG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'IBABAO',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'LAMBOJON',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'LUYANG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'LUZONG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'OLO',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'PANLAUTAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'PASIHAGON',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'POLANGYUTA',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'PONONG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'SONGCULAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'TACDOG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'TACLOBAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'TAMBISAN',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'TEBJONG',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'SIQUIJOR',
        BARANGAY: 'TONGO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CANASAGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CANDURA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CANGMUNAG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CANSAYANG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CATULAYAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LALA-O',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'MAITE',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PALITON',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SOLANGON',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TAG-IBO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TAMBISAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TIMBAON',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'ALBIGA',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'APOLOY',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'BONAWON',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'BONBONON',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'CANAWAY',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'CASALA-AN',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'CATICUGAN',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'DATAG',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'GILIGA-ON',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'INALAD',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'MALABUHAN',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'MALOH',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'MANTIQUIL',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'MANTUYOP',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'NAPACAO',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'POBLACION LII',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'SALAG',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'SANDULOT',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'SI-IT',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'SUMALIRING',
    },
    {
        CITY: 'SIATON',
        BARANGAY: 'TAYAK',
    }
];
